import React from 'react';
import { toast, ToastOptions } from "react-toastify";
interface IToastifyProps {
    "title":string,
    "message":string,
    "isSuccessful":boolean
}
const toastify= ({isSuccessful,message, title}: IToastifyProps)=>{
 const content=(  <div>
        <h4 style={{textAlign:"left"}}>{title}</h4>
        <p style={{textAlign:"left"}}>{message}</p>
    </div>);
 const options: ToastOptions ={
     position: "bottom-right",
     autoClose: 4000,
     hideProgressBar: false,
     closeOnClick: true,
     pauseOnHover: true,
     draggable: true,
     progress: undefined,
     theme: "light",
 }
    if (isSuccessful) {
        toast.success(content, options);
    } else {
        toast.error(content, options);
    }
}
export default toastify;